import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Instagram } from "lucide-react";
import { RevealLine } from "./Reveal";
import MiniSign from "./MiniSign";

const HERO_IMG = "/hero.jpg";

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);

  return (
    <section ref={ref} id="top" data-testid="hero-section" className="relative min-h-screen overflow-hidden">
      <motion.div style={{ y: bgY }} className="absolute inset-0">
        <img src={HERO_IMG} alt="Interno ristrutturato da FKL" className="w-full h-full object-cover brightness-[0.92]" />
        <div className="absolute inset-0 bg-black/10" />
        <div className="absolute inset-0 bg-[#F4F1EA]/10" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-black/10" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 lg:px-10 pt-44 lg:pt-52">
        <div className="w-fit max-w-full">
          <RevealLine delay={0.2}>
            <span className="block text-[11px] sm:text-xs font-semibold uppercase tracking-[0.35em] text-white [text-shadow:0_1px_12px_rgba(0,0,0,0.35)]">
              Rifacimento interni&nbsp;&nbsp;–&nbsp;&nbsp;Costruzioni&nbsp;&nbsp;–&nbsp;&nbsp;Progettazione&nbsp;&nbsp;–&nbsp;&nbsp;Render 3D&nbsp;&nbsp;–&nbsp;&nbsp;Calcolo strutturale&nbsp;&nbsp;–&nbsp;&nbsp;Pratiche
            </span>
          </RevealLine>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ delay: 0.5, duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="mt-8 h-px bg-white/80 ml-[7%] mr-[5%]"
          />
          <h1 data-testid="hero-headline" className="mt-8 font-display font-medium leading-[1.1] tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white lg:whitespace-nowrap text-center [text-shadow:0_1px_16px_rgba(0,0,0,0.35)]">
            <RevealLine delay={0.65}>Costruiamo valore nel tempo</RevealLine>
          </h1>
        </div>
      </div>

      <motion.img
        src="/fkl-logo.png"
        alt="FKL srls"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.1, duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="absolute bottom-10 right-8 sm:right-14 w-28 sm:w-40"
      />
      <div className="absolute bottom-2 inset-x-0 z-10">
        <MiniSign />
      </div>
      <a
        href="https://www.instagram.com/fkl.official_"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram FKL"
        data-testid="ig-float-hero"
        className="absolute bottom-4 left-6 z-10 w-12 h-12 rounded-full bg-[#1C1B1A] flex items-center justify-center text-white hover:bg-[#E30613] hover:scale-110 transition-[background-color,transform] duration-300"
      >
        <Instagram className="w-5 h-5" strokeWidth={1.75} />
      </a>
    </section>
  );
}
